import { Result } from "antd";
import { BASE_PATH } from "../../api/api";
import { calculaColor } from "../../utils/functions";

export default function Responder({ response }) {
  if (!response.found) {
    return <Result status="error" title="Lo sentimos" subTitle="No encontramos al postulante" />;
  } else {
    const { data } = response;

    const pStyle = {
      color: "white",
      textShadow: "-2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000"
    };

    return (
      <div className="text-center">
        <h1
          className={
            "text-lg text-center p-1 text-white font-semibold " +
            (response.duplicado ? "bg-red-400" : "bg-green-500")
          }
        >
          {data?.nombre + " " + data?.apellido}
        </h1>
        {response.duplicado && <p className="text-sm my-2 text-red-600">YA SE MARCÓ ASISTENCIA</p>}
        <div className="text-sm my-2">
          DNI: <span className="font-bold">{data?.nrodocumento || ""}</span> | CÓDIGO:{" "}
          <span className="font-bold">{data?.codigo || ""}</span>
        </div>
        <img
          className="mx-auto border-8"
          style={{ borderColor: calculaColor(data?.color) }}
          src={data?.fotografia}
          width={150}
          height={180}
          alt={"fotografia de postulante " + data?.nrodocumento}
        />

        <div className="text-center mx-auto flex items-center flex-col justify-center mb-5">
          <div className="font-bold">AULA:</div>
          <div
            className="w-20 h-16 flex items-center justify-center border"
            style={{ background: calculaColor(data?.color) }}
          >
            <p className="text-4xl font-bold text-white tracking-wider" style={pStyle}>
              {" "}
              {data?.aula || ""}
            </p>
          </div>
        </div>

        <div>
          <div className="font-bold">PABELLÓN:</div>
          <p className="text-xl font-bold">{data?.pabellon || ""}</p>
        </div>
      </div>
    );
  }
}
